module.exports = __webpack_public_path__ + "img/Kid4.08bdd132.png";